import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 20, 50],
  totalRows: 1,
  sortOptions: [],
  options: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'description', label: 'Description' },
    { key: 'company_name', label: 'Company Name' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/projects', params }
    useIPA.get(param).then(response => {
      const project = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...project })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/project/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        company_id: formData.select_1,
        name: formData.text_1,
        description: formData.text_2,
      }
      const param = { rawData, url: 'internal/master/project', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/project', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, project) {
    state.items = project.rows
    state.totalRows = project.rows.length
    state.options = []
    for (let i = 0; i < project.rows.length; i++) {
      const option = []
      for (const key in project.rows[i]) {
        if (key === 'id') {
          option.value = project.rows[i][key]
        } else if (key === 'name') {
          option.title = project.rows[i][key]
        } else if (key === 'id') {
          option.oid = project.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
